import * as z from "zod";
import { TestResult } from "./TestResult";
export const TestResults = z.object({
    version: z.literal("v1.0"),
    test_results: TestResult.array(),
});
